import authAxios from "./authAxios";
import { endpoints } from "../../api/endpoints";

export const sessionService = {
  getLocations,
  startSession,
  check,
};

function getLocations(data) {
  return authAxios({
    url: endpoints.session.getLocations,
    method: "POST",
    data: data ? data : {},
    headers: {
      "Content-Type": "application/json",
    },
  });
}

function startSession(data) {
  return authAxios({
    url: endpoints.session.startSession,
    method: "POST",
    data: {
      location_id: data.locationId
    },
    headers: {
      "Content-Type": "application/json",
    },
  });
}

function check({ sessionToken }) {
  return authAxios({
    url: endpoints.session.check + "/" + sessionToken,
    method: "GET",
  });
}
